<template>
  <div class="mb-2 date-input d-flex single-input">
    <b-button-group>
      <b-button variant="primary" class="p-0">
        <v-date-picker v-model="rangeRaw" is-range class="p-0">
          <template #default="{ inputEvents }">
            <img
              :src="asset('/imgs/icons/date-range.png')"
              alt="calendar"
              title="calendar"
              class="calendar"
              v-on="inputEvents.start"
            />
          </template>
        </v-date-picker>
      </b-button>
      <b-button variant="primary" class="p-0">
        <v-date-picker
          v-model="rangeRaw.start"
          @dayclick="dateChanged('start')"
        >
          <template #default="{ inputEvents }">
            <span v-if="rangeRaw.start" class="pl-1" v-on="inputEvents">
              {{ rangeRaw.start | formatDateFilter }}
            </span>
            <span v-else class="place-holder pl-1" v-on="inputEvents">
              Start date
            </span>
          </template>
        </v-date-picker>
      </b-button>
      <b-button variant="primary" disabled class="px-0">-</b-button>
      <b-button variant="primary" class="p-0">
        <v-date-picker v-model="rangeRaw.end" @dayclick="dateChanged('end')">
          <template #default="{ inputEvents }">
            <span v-if="rangeRaw.end" class="pr-1" v-on="inputEvents">
              {{ rangeRaw.end | formatDateFilter }}
            </span>
            <span v-else class="place-holder pr-1" v-on="inputEvents">
              End date
            </span>
          </template>
        </v-date-picker>
      </b-button>
      <b-button variant="primary" @click="clearDates()">
        <img
          :src="asset('/imgs/icons/close-gray.png')"
          alt="close"
          title="Clear dates"
          class="close-icon"
        />
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    initialRange: {
      type: [Array, Object],
      default() {
        return {
          start: null,
          end: null,
        };
      },
    },
  },
  data() {
    return {
      rangeRaw: {
        start: null,
        end: null,
      },
      initialSet: false,
    };
  },
  watch: {
    initialRange(val) {
      if (val && !this.initialSet) {
        this.rangeRaw = {
          start: val.start ? val.start : null,
          end: val.end ? val.end : null,
        };
        this.rangeRaw = { ...this.rangeRaw };
        this.initialSet = true;
      }
    },
    rangeRaw() {
      this.onRangeChange();
    },
  },
  created() {
    this.rangeRaw = { ...this.initialRange };
  },
  methods: {
    clearDates() {
      this.rangeRaw = { start: null, end: null };
    },
    dateChanged(day) {
      this.rangeRaw = {
        ...this.rangeRaw,
        [day]: this.rangeRaw[day],
      };
    },
    onRangeChange() {
      this.$emit('rangeChange', this.rangeRaw);
    },
  },
};
</script>
